import { InspectionCase } from './inspection-case.dto';

export class InspectionTimeCaseDto extends InspectionCase {
  time?: number; // min
}
export class InspectionTimeCase extends InspectionTimeCaseDto {
  constructor(data: InspectionTimeCaseDto = {}) {
    super(data);
    this.time = data.time || 0;
  }
}
